export const VIDEO_TEST_ID = 'smart-wearable-video'
